import { jsx as t, jsxs as r } from "react/jsx-runtime";
import { fcds as i, ThemeProvider as s } from "@ucl/shared-component-foundations";
import { styled as d } from "styled-components";
const l = /* @__PURE__ */ d.div.withConfig({
  displayName: "withAuthorView__StyledAuthorView",
  componentId: "sc-a0c4a134-0"
})([
  ".UCLAuthorView__select{display:flex;justify-content:center;border:1px dashed ",
  ";background:#0562d21a;padding:",
  ";flex-direction:column;align-items:center;box-sizing:border-box;}"
], i.semanticMode1.color.stroke.onLight.interactive.value, i.semanticMode1.space.lg.value);
function w(o, a) {
  function c() {
    const n = new URLSearchParams(window.parent.location.search).get("view") ?? Object.keys(o)[0];
    return /* @__PURE__ */ t(l, {
      children: /* @__PURE__ */ r(s, {
        productTeamName: "AEM Provider",
        children: [
          /* @__PURE__ */ r("div", {
            className: "UCLAuthorView__select",
            children: [
              "Select your state (please note that this selector is just for lower environment testing only. Do not use in production):",
              /* @__PURE__ */ t("select", {
                id: "author-select",
                onChange: (e) => {
                  typeof window < "u" && (window.parent.location.href = window.parent.location.origin + window.parent.location.pathname + `?view=${e.target.value}`);
                },
                children: Object.keys(o).map((e) => /* @__PURE__ */ t("option", {
                  selected: n === e,
                  value: e,
                  children: e
                }))
              })
            ]
          }),
          /* @__PURE__ */ t(a, {
            ...o[n]
          })
        ]
      })
    });
  }
  return c;
}
export {
  w
};
